export default __webpack_public_path__ + "assets/634f17b8a0f483c987b71bb6b0fd6765.svg";